module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-10"
  }, [_c('vuetable', {
    ref: "vuetable",
    attrs: {
      "api-url": (_vm.server + "/api/event/"),
      "data-path": "results",
      "fields": _vm.fields,
      "http-options": _vm.httpOptions,
      "css": _vm.boostrapCss,
      "pagination-path": "",
      "append-params": _vm.moreParams,
      "per-page": 20
    },
    on: {
      "vuetable:pagination-data": _vm.onPaginationData
    }
  }), _c('vuetable-pagination', {
    ref: "pagination",
    attrs: {
      "css": _vm.boostrapCss.pagination
    },
    on: {
      "vuetable-pagination:change-page": _vm.onChangePage
    }
  })], 1), _c('div', {
    staticClass: "col-2"
  }, [_c('QueryFilter', {
    attrs: {
      "showMedRecordNum": true,
      "showMedication": true
    },
    on: {
      "filter": _vm.filter,
      "report": _vm.report
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c502b05","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin/ReportExport/EventSummary.vue
// module id = 1502
// module chunks = 1